import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    outerContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0px 24px 24px 24px',
      minWidth: '100%',
      background: 'transparent'
    },
    lookupViewWrapper: {
      background: 'white',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      flexWrap: 'nowrap',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      justifyContent: 'center',
      height: '500px',
      [theme.breakpoints.down('lg')]: {
        height: '1385px'
      }
    },
    inputContainer: {
      width: '675px',
      background: 'transparent',
      margin: '10px 0px 10px 0px',
      [theme.breakpoints.down('lg')]: {
        margin: '16px 0px 64px 0px'
      }
    }
  })
);
